/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Font_Size_LabelInputs */

const en_image_export_font_size_label = /** @type {(inputs: Image_Export_Font_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Size`)
};

const fr_image_export_font_size_label = /** @type {(inputs: Image_Export_Font_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taille`)
};

const de_image_export_font_size_label = /** @type {(inputs: Image_Export_Font_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Größe`)
};

const it_image_export_font_size_label = /** @type {(inputs: Image_Export_Font_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Misurare`)
};

const ru_image_export_font_size_label = /** @type {(inputs: Image_Export_Font_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Размер`)
};

const es_image_export_font_size_label = /** @type {(inputs: Image_Export_Font_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamaño`)
};

const zh_cn2_image_export_font_size_label = /** @type {(inputs: Image_Export_Font_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尺寸`)
};

const ja_image_export_font_size_label = /** @type {(inputs: Image_Export_Font_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サイズ`)
};

const hi_image_export_font_size_label = /** @type {(inputs: Image_Export_Font_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आकार`)
};

const pt_pt2_image_export_font_size_label = /** @type {(inputs: Image_Export_Font_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamanho`)
};

/**
* | output |
* | --- |
* | "Size" |
*
* @param {Image_Export_Font_Size_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_font_size_label = /** @type {((inputs?: Image_Export_Font_Size_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Font_Size_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_font_size_label(inputs)
	if (locale === "de") return de_image_export_font_size_label(inputs)
	if (locale === "it") return it_image_export_font_size_label(inputs)
	if (locale === "ru") return ru_image_export_font_size_label(inputs)
	if (locale === "es") return es_image_export_font_size_label(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_font_size_label(inputs)
	if (locale === "ja") return ja_image_export_font_size_label(inputs)
	if (locale === "hi") return hi_image_export_font_size_label(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_font_size_label(inputs)
	return en_image_export_font_size_label(inputs)
});